import { render, staticRenderFns } from "./CreateBuildingTab.vue?vue&type=template&id=105ee55d&scoped=true"
import script from "./CreateBuildingTab.vue?vue&type=script&lang=js"
export * from "./CreateBuildingTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105ee55d",
  null
  
)

export default component.exports